var utils = require('./extrax2-webadmin.utils.js');

function ajaxCall(url, type, data, show_breadcrumb, done) {
	ajaxCallExtended(url, type, data, show_breadcrumb, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, null, true, null, done);
}

function ajaxCallExtended(url, type, data, show_breadcrumb, processData, contentType, headerKeys, xhrFields, cache, fail, done) {

	let container = $('#content');

	if (show_breadcrumb) {
		$('nav li.active').removeClass("active");
		// match the url and add the active class
		$('nav li:has(a[href="' + url + '"])').addClass("active");
		var title = ($('nav a[href="' + url + '"]').attr('title'));

		// change page title from global var
		document.title = (title || document.title);
	}

	var promise = $.ajax({
		url: url,
		type: type,
		data: data,
		async: true,
		cache: cache,
		processData: processData,
		contentType: contentType,
		xhrFields: xhrFields,
		beforeSend: function (xhr) {
			if (headerKeys !== null) {
				xhr.setRequestHeader(headerKeys[0], headerKeys[1]);
			}
			xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
			if (show_breadcrumb) {
				container.empty();
				App.blockUI({
					target: 'body',
					animate: true
				});

				if (container[0] == $("#content")[0]) {
					drawBreadCrumb(Lang.get('extrax2-webadmin.admin_title'));

					// scroll up
					$("html, body").animate({
						scrollTop: 0
					}, "fast");

				} else {
					container.animate({
						scrollTop: 0
					}, "fast");
				}
			}
		}
	}).done(function (data, status, xhr) {
		if (/^FAILS/.test(data) || /^Error/.test(data)) {
			swal({
					title: trans('extrax2-webadmin.error'),
					text: trans('extrax2-webadmin.error_message'),
					type: 'error',
					allowOutsideClick: true,
					confirmButtonClass: 'btn-danger'
				},
				function(isConfirm){

				});

			return;
		}
		
		done(data, status, xhr);
	}).fail(function (error) {
		if (fail === null) {
			if (error.status == "401") {
				location.reload();
			} else {
				utils.setHtmlData($("#content"), error.responseText);
			}
		} else {
			fail(error);
		}
	});

	return promise;
}

function ajaxCallDeferred(url, type, data, show_breadcrumb) {

	return ajaxCallDeferredExtended(url, type, data, show_breadcrumb, true, 'application/x-www-form-urlencoded; charset=UTF-8', null);
}

function ajaxCallDeferredExtended(url, type, data, show_breadcrumb, processData, contentType, headerKeys) {

	let container = $('#content');

	if (show_breadcrumb) {
		$('nav li.active').removeClass("active");
		// match the url and add the active class
		$('nav li:has(a[href="' + url + '"])').addClass("active");
		var title = ($('nav a[href="' + url + '"]').attr('title'));

		// change page title from global var
		document.title = (title || document.title);
	}

	var promise = $.ajax({
		url: url,
		type: type,
		data: data,
		async: true,
		processData: processData,
		contentType: contentType,
		beforeSend: function (xhr) {
			if (headerKeys !== null) {
				xhr.setRequestHeader(headerKeys[0], headerKeys[1]);
			}
			xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
			if (show_breadcrumb) {
				container.empty();
				App.blockUI({
					target: 'body',
					animate: true
				});

				if (container[0] == $("#content")[0]) {
					drawBreadCrumb(Lang.get('extrax2-webadmin.admin_title'));

					// scroll up
					$("html, body").animate({
						scrollTop: 0
					}, "fast");

				} else {
					container.animate({
						scrollTop: 0
					}, "fast");
				}
			}
		}
	}).fail(function(error) {

		console.error(error);
		if (error.status == "401") {
			location.reload();
		} else {
			utils.setHtmlData($("#content"), error.responseText);
		}
	});

	return promise;
}

function ajaxSucceeded(data) {

	if (/^FAILS/.test(data)) {
		swal({
				title: trans('extrax2-webadmin.error'),
				text: trans('extrax2-webadmin.error_message'),
				type: 'error',
				allowOutsideClick: true,
				confirmButtonClass: 'btn-danger'
			},
			function(isConfirm){

			});

		return false;
	}

	return true;
}

function drawBreadCrumb(homeText) {
	var nav_elems = $('nav li.active > a'),
		 count = nav_elems.length,
		 bread_crumb = $('#ribbon ol.breadcrumb');

	bread_crumb.empty();
	bread_crumb.append($("<li>" + homeText + "</li>"));
	nav_elems.each(function () {
		bread_crumb.append($("<li></li>").html($.trim($(this).clone().children(".badge").remove().end().text())));
		// update title when breadcrumb is finished...
		if (!--count) {
			document.title = $("<li></li>").html($.trim($(this).clone().children(".badge").remove().end().text())).text();
		}
	});

	// clear dom reference
	nav_elems = null;
}

module.exports.ajaxCall = ajaxCall;
module.exports.ajaxCallExtended = ajaxCallExtended;
module.exports.ajaxCallDeferred = ajaxCallDeferred;
module.exports.ajaxCallDeferredExtended = ajaxCallDeferredExtended;
module.exports.ajaxSucceeded = ajaxSucceeded;
